import { Phone } from "lucide-react";
import { COMPANY, waLink } from "../data/site";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-24 right-5 z-[9998] flex flex-col items-end gap-3" data-testid="floating-actions">
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        aria-label="Contacter sur WhatsApp"
        className="bg-[#25D366] text-white w-14 h-14 rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform"
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-current">
          <path d="M16.004 5.333c-5.89 0-10.667 4.776-10.667 10.667 0 1.88.49 3.72 1.42 5.34L5.333 26.667l5.5-1.44a10.62 10.62 0 0 0 5.17 1.32h.004c5.89 0 10.667-4.776 10.667-10.667 0-2.85-1.11-5.53-3.127-7.546a10.6 10.6 0 0 0-7.543-3.001zm0 19.2h-.003a8.86 8.86 0 0 1-4.51-1.235l-.323-.192-3.264.856.87-3.18-.21-.327a8.84 8.84 0 0 1-1.355-4.722c0-4.896 3.984-8.88 8.884-8.88a8.82 8.82 0 0 1 6.276 2.604 8.82 8.82 0 0 1 2.598 6.28c0 4.896-3.984 8.88-8.88 8.88zm4.872-6.652c-.267-.134-1.58-.78-1.825-.868-.244-.09-.422-.134-.6.134-.178.267-.69.867-.846 1.045-.156.178-.31.2-.578.067-.267-.134-1.127-.415-2.146-1.324-.793-.708-1.328-1.582-1.484-1.85-.156-.267-.017-.41.117-.544.12-.12.267-.31.4-.466.134-.156.178-.267.267-.445.09-.178.045-.334-.022-.467-.067-.134-.6-1.447-.823-1.98-.216-.52-.436-.45-.6-.458l-.51-.01a.98.98 0 0 0-.712.334c-.244.267-.934.912-.934 2.225s.957 2.58 1.09 2.758c.134.178 1.882 2.874 4.56 4.03.637.275 1.134.44 1.522.563.64.204 1.222.175 1.682.106.513-.077 1.58-.646 1.804-1.27.222-.623.222-1.158.155-1.27-.066-.111-.244-.178-.51-.312z" />
        </svg>
      </a>
      <a
        href={`tel:${COMPANY.phoneRaw}`}
        data-testid="call-float-btn"
        aria-label="Appeler MS Énergie"
        className="bg-brand text-white w-14 h-14 rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform animate-pulse-ring"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
